import React from "react";
import { graphql } from 'gatsby';
import ReactMarkdown from "react-markdown";
import SEO from '../components/Seo';
import Layout from "../components/Layout";
import Header from "../components/Header/Header";

const ProgramPage = ({
  data: {
    allStrapiProgram: { nodes: program }
  }
}) => {
  const { header, headerImage, content } = program[0];
  return (
    <Layout>
      <SEO
        pageTitle={'Programa'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      <Header
        title={header.title}
        subtitle={header.subtitle}
        image={headerImage}
      />
      <div style={{ width: '100%', maxWidth: '100%', minHeight: "calc(100vh - 550px)" }}>
        <ReactMarkdown className="markdown-page" source={content} />
      </div>
    </Layout>
  );
};

export const query = graphql`
  {
    allStrapiProgram {
      nodes {
        content
        header {
          title
          subtitle
        }
        headerImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default ProgramPage;
